module.exports = {"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-simple.json
// module id = 147
// module chunks = 60335399758886 271610249085153